import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => {
  const isDark = theme.palette.type === 'dark'
  const {
    palette: {
      blue_300: { main: blue300 } = {},
      green_200: { main: green200 } = {},
      gray_400: { main: gray400 } = {},
      gray_100: { main: gray100 } = {},
      gray_stroke: { main: grayStroke } = {},
      white_100: { main: white100 } = {},
      red_100: { main: red100 } = {},
      red_200: { main: red200 } = {},
      dark_50: { main: dark50 } = {},
      dark_600: { main: dark600 } = {},
      dark_stroke: { main: darkStroke } = {}
    } = {}
  } = theme
  return {
    mainPaper: {
      flex: 1,
      padding: '0px 8px 0 8px',
      overflowY: 'scroll',
      ...theme.scrollbarStyles,
      border: 'none'
    },
    buttonContainer: {
      display: 'flex',
      gap: '8px'
    },
    boxForms: {
      padding: '4px 20px 0 20px',
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.dark_400.main
          : theme.palette.white_100.main
    },

    profileSwitchContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start'
    },

    //Tabs
    tab: {
      borderBottom: isDark
        ? `1px solid ${darkStroke}`
        : `1px solid ${grayStroke}`,
      '& .MuiTab-root': {
        minHeight: '28px',
        minWidth: '110px',
        backgroundColor: isDark ? dark600 : gray100
      },
      '& .MuiTabs-indicator': {
        display: 'none'
      },
      '& .MuiTabScrollButton-root': {
        width: '25px'
      }
    },
    tabHeader: {
      // backgroundColor: blue300,
      borderRadius: '8px 8px 0 0',
      margin: '12px 0 0 0',
      padding: '2px 4px',
      position: 'relative',
      zIndex: 1,
      // boxShadow: '0 2px 5px rgba(0,0,0,0.1)',

      '&.Mui-selected': {
        backgroundColor: blue300,
        color: white100,
        zIndex: 2,
        '& span': {
          color: white100
        }
      }
    },

    //Schedules
    groupTitle: {
      margin: 0,
      color: blue300,
      fontWeight: '600',
      fontSize: '1rem',
      marginBottom: '12px'
    },
    queueContainer: {
      display: 'flex',
      gap: '8px',
      margin: '8px 0'
    },
    queueItem: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '10px',
      // gap: '8px',
      border: isDark ? '1px solid' + darkStroke : '1px solid' + grayStroke,
      borderRadius: 10,
      minWidth: '120px',
      cursor: 'pointer',
      height: '40px',
      color: isDark ? dark50 : gray400
    },
    iconButton: {
      backgroundColor: 'transparent',
      color: blue300,
      padding: 0,
      '&:hover': {
        backgroundColor: 'transparent'
      }
    },
    boxHours: {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '8px',
      borderRadius: 8,
      backgroundColor: red200,
      color: red100
    },
    buttonAddNewHour: {
      border: 'dashed 1px',
      height: '39px',
      borderRadius: 10,
      color: isDark ? darkStroke : grayStroke,
      '& span': {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        color: isDark ? dark50 : gray400,
        '& svg': {
          color: blue300
        }
      }
    },
    containerPagination: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '8px 4px',
      border: '1px solid red'
    },
    countPerPage: {
      marginLeft: 16,
      color: isDark ? dark50 : gray400
    },
    exibitionPagination: {
      display: 'flex',
      alignItems: 'center',
      gap: 24
    },
    perPageSelect: {
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      '& p': {
        color: isDark ? dark50 : gray400
      }
    },
    buttonNext: {
      backgroundColor: 'transparent',
      color: isDark ? dark50 : gray400,
      padding: 0,
      '&:hover': {
        backgroundColor: 'transparent',
        color: blue300
      }
    },
    pageNumberOfRowsPage: {
      color: isDark ? dark50 : gray400,
      margin: '0 16px'
    }
  }
})
